import { Machine, Condition } from "model/dataTypes";

const getSimID = (machine: Machine, condition: Condition, relHTarget: number) => {
  let id = `${machine.heatExhangerDimensions.depth}_${machine.heatExhangerDimensions.length}_${machine.heatExhangerDimensions.height}_${condition.extractAir}_${condition.extractFlow}_${condition.extractHumidity}_${condition.outsideAir}_${condition.outsideFlow}_${condition.outsideHumidity}_${relHTarget}`;
  return id;
};

export default getSimID;
